/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerOnlinePaymentStatusEnum as ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum } from '../../models/Models/Customer/Enums/customer-online-payment-status-enum';

export interface V4CustomersMeOnlinePaymentsIdStatusGet$Plain$Params {
  id: string;
}

export function v4CustomersMeOnlinePaymentsIdStatusGet$Plain(http: HttpClient, rootUrl: string, params: V4CustomersMeOnlinePaymentsIdStatusGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum>> {
  const rb = new RequestBuilder(rootUrl, v4CustomersMeOnlinePaymentsIdStatusGet$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum>;
    })
  );
}

v4CustomersMeOnlinePaymentsIdStatusGet$Plain.PATH = '/v4/customers/me/online-payments/{id}/status';
